module.exports = __webpack_public_path__ + "img/selected3-min.6666190e.png";